import { _isNotEmpty } from '@/littledash';
import type { StudyDraft } from '@/model/Draft.model';

/**
 * Encodes comma characters in multi-select and lookup multi-select metadata values
 * to handle legacy drafts that may have non-encoded values.
 *
 * This function mutates the draft in place by encoding commas in metadata values
 * for multi_select and lookup_multi_select field types within treatment groups.
 *
 * @param draft - The StudyDraft to process
 */
export const encodeGroupMultiSelectMetadata = (draft: StudyDraft): void => {
  if (!_isNotEmpty(draft?.form_data?.groups)) {
    return;
  }

  draft.form_data.groups.forEach((group) => {
    if (!_isNotEmpty(group.metadata)) {
      return;
    }

    group.metadata.forEach((metadata) => {
      if (metadata.field_type !== 'multi_select' && metadata.field_type !== 'lookup_multi_select') {
        return;
      }

      if (!Array.isArray(metadata.value)) {
        return;
      }

      metadata.value = metadata.value.map((valueItem) => {
        if (typeof valueItem === 'string' && valueItem.includes(',')) {
          return encodeURIComponent(valueItem);
        }
        return valueItem;
      });
    });
  });
};
